
export const ALL_PURCHASE_ORDER_REQUEST = "ALL_PURCHASE_ORDER_REQUEST";
export const ALL_PURCHASE_ORDER_SUCCESS = "ALL_PURCHASE_ORDER_SUCCESS";
export const ALL_PURCHASE_ORDER_FAIL = "ALL_PURCHASE_ORDER_FAIL";